/**
 * Render a pop-up menu, different for mobile and desktop.
 */

import { className } from "utils/strings";
import { IMenuGroup, IMenuItem } from "./types";

import "./PopupMenu.scss";

export const PopupMenu = (props: {
  groups: IMenuGroup[];
  onClick: (item: IMenuItem) => void;
  onClose: () => void;
  className?: string;
}): JSX.Element => {
  const onClick = (item: IMenuItem) => () => {
    props.onClick(item);
  };

  const onClose = () => {
    props.onClose();
  };

  return (
    <div className={className({
      "popupMenu": true,
      [props.className ?? ""]: true,
    })}>
      <div className="backdrop" onClick={onClose}></div>

      <div className="canvas">
        <div className="grip"></div>

        {props.groups.map((group: IMenuGroup, gidx: number) => (
          <div key={gidx} className={className({
            "group": true,
            [group.className ?? ""]: true,
          })}>
            {group.text && (
              <div className="groupName">{group.text}</div>
            )}

            <div className="items">
              {group.items.map((item: IMenuItem, iidx: number) => (
                <div className={className({
                  "item": true,
                  [item.className ?? ""]: true,
                })} key={iidx} onClick={onClick(item)}>
                  {item.icon}
                  <span className="label">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="items">
        </div>
      </div>
    </div>
  );
};
